import { useGetAllJobPostsQuery } from '@/app/features/recruitment/job-applicants/job-applicants.api';
import CustomTable from '@/components/CustomTable';
import StatusTag from '@/components/StatusTag';
import { FILTER_KEYS } from '@/constants/keys.constants';
import { useAppFilters } from '@/hooks';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

// Fixed date range: from 1 month ago up to yesterday — computed once at module level
const PUBLISH_DATE_START = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
const PUBLISH_DATE_END = dayjs().subtract(1, 'day').format('YYYY-MM-DD');

const STATUS_CONFIG = [
  {
    label: 'Published',
    value: 'PUBLISHED',
    className: 'status status-success',
  },
  { label: 'Draft', value: 'DRAFT', className: 'status status-yellow' },
  { label: 'Closed', value: 'CLOSED', className: 'status status-error' },
];

const columns: ColumnsType<any> = [
  {
    title: 'Role',
    dataIndex: 'job_title',
    render: (val: string) => val || 'n/a',
  },
  {
    title: 'Vacancies',
    dataIndex: 'vacancy',
    align: 'center',
    render: (val: number) => val ?? 'n/a',
  },
  {
    title: 'Total Applied',
    dataIndex: 'total_applicant',
    align: 'center',
    render: (val: number) => val ?? 'n/a',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    align: 'center',
    render: (val: string) => <StatusTag value={val} config={STATUS_CONFIG} />,
  },
  {
    title: 'Evaluator',
    dataIndex: 'evaluator_name',
    align: 'center',
    render: (val: string | null) => val || 'n/a',
  },
  {
    title: 'Published On',
    dataIndex: 'publish_date',
    align: 'center',
    render: (val: string) => (val ? dayjs(val).format('YYYY/MM/DD') : 'n/a'),
  },
];

export default function RecentJobPost() {
  const { page, limit, handlePagination } = useAppFilters(
    FILTER_KEYS.RM_RECENT_JOB_POST,
    { defaultLimit: 6 },
  );

  const { data, isLoading, isFetching } = useGetAllJobPostsQuery({
    params: {
      publish_date_start: PUBLISH_DATE_START,
      publish_date_end: PUBLISH_DATE_END,
      limit: 6,
      skip: (page - 1) * limit,
    },
  });

  const jobs = data?.data?.data ?? [];
  const total = data?.data?.meta?.total ?? 0;

  return (
    <div>
      <div className="text-white rounded-xl shadow-xl bg-theme-slate-800 border border-theme-gray-700 recent-job-post max-h-[515px]">
        <CustomTable
          page={page}
          limit={limit}
          hideRowSelect
          columns={columns}
          dataSource={jobs}
          onPaginate={handlePagination}
          tableRootClassName="border-0 p-0"
          customTitle="Recent Job Posts"
          loading={isLoading || isFetching}
          total={total}
        />
      </div>
    </div>
  );
}
